import Typography from "@mui/material/Typography";
import ReactTimeAgo from "react-time-ago";
import MenuItem from "@mui/material/MenuItem";
import {Dispatch, FC, SetStateAction, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {RootState, useAppDispatch, useAppSelector} from "../../../store";
import {INotification} from "../../../store/notification/Helper";
import {alpha} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import NotificationService from "../../../api/notificationService";
import {toastError} from "../../shared/toast/Toast";
import {readNotification} from "../../../store/notification/Slice";

interface IProps {
    notification: INotification
    setAnchorEl: Dispatch<SetStateAction<null | HTMLElement>>
}

const NotificationItem: FC<IProps> = (props) => {
    const {t, i18n} = useTranslation()
    const language = useAppSelector((state: RootState) => state.appReducer.language)
    const dispatch = useAppDispatch()
    const theme = useTheme()

    const handleReadNotification = async () => {
        props.setAnchorEl(null)
        if (!props.notification.read) {
            try {
                await NotificationService.readNotification(props.notification.id)
                dispatch(readNotification(props.notification.id))
            } catch (e) {
                toastError(t('error_occurred'))
            }
        }
        if (props.notification.link) {
            const currentHostname = window.location.hostname;
            const linkUrl = new URL(props.notification.link);
            const linkHostname = linkUrl.hostname;

            // Check if the link's hostname matches the current hostname
            if (linkHostname === currentHostname) {
                // If yes, navigate in the same tab
                window.location.href = props.notification.link;
            } else {
                // If not, open the link in a new tab
                window.open(props.notification.link, '_blank');
            }
        }
    }

    const getTimeAgoLocale = useMemo(() => {
        switch (language) {
            case "en":
                return "en-US"
            case "al":
                return "sq-SQ"
            default:
                return "mk-MK"
        }
    }, [language])

    return (
        <MenuItem onClick={handleReadNotification}
                  sx={{
                      display: 'block',
                      whiteSpace: 'initial',
                      backgroundColor: !props.notification.read ? alpha(theme.palette.quaternary.main, .1) : theme.palette.primary.main
                  }}>
            <Typography variant="subtitle1" fontWeight="bold">
                {props.notification[`title_${i18n.language}`]}
            </Typography>
            <Typography variant="subtitle2" sx={{color: 'text.secondary'}}>
                <ReactTimeAgo date={new Date(props.notification.created_at)} locale={getTimeAgoLocale}/>
            </Typography>
            <Typography variant="subtitle2">
                {props.notification[`content_${i18n.language}`]}
            </Typography>
        </MenuItem>
    )
}

export default NotificationItem